import React from "react";
import {IPoint} from "../interfaces/IPoint";
import {IRect} from "../interfaces/IRect";
import {ISize} from "../interfaces/ISize";

export class CanvasUtil {
    public static getMousePositionOnCanvasFromEvent(event: React.MouseEvent<HTMLCanvasElement, MouseEvent> | MouseEvent, canvas: HTMLCanvasElement): IPoint {
        if (!!canvas && !!event) {
            return CanvasUtil.getMousePositionOnCanvasFromClientPoint(
                event.clientX,
                event.clientY,
                canvas
            );
        }
        return null;
    }

    public static getMousePositionOnCanvasFromClientPoint(
        clientX: number,
        clientY: number,
        canvas: HTMLCanvasElement
    ): IPoint {
        if (!canvas) return null;
        const canvasRect: ClientRect | DOMRect = canvas.getBoundingClientRect();
        return {
            x: clientX - canvasRect.left,
            y: clientY - canvasRect.top
        };
    }

    public static getClientRect(canvas: HTMLCanvasElement): IRect {
        if (!!canvas) {
            const canvasRect: ClientRect | DOMRect = canvas.getBoundingClientRect();
            return {
                x: canvasRect.left,
                y: canvasRect.top,
                width: canvasRect.width,
                height: canvasRect.height
            }
        }
        return null;
    }

    public static getSize(canvas: HTMLCanvasElement): ISize {
        if (!!canvas) {
            const canvasRect: ClientRect | DOMRect = canvas.getBoundingClientRect();
            return {
                width: canvasRect.width,
                height: canvasRect.height
            }
        }
        return null;
    }
}